// extracted by mini-css-extract-plugin
module.exports = {"part2Root":"index-part2Root-ChrES","part2Title":"index-part2Title-1Q6__","featureSwiper":"index-featureSwiper-1mxAk","featurePagination":"index-featurePagination-23iwd"};